import React from 'react';

const NotFound = () => (
  <div className="container mx-auto p-8 bg-white rounded-lg shadow-lg my-8 border border-gray-200 text-center">
    <h1 className="text-4xl font-extrabold text-black mb-8">404 - Page Not Found</h1>
    <p className="text-gray-800">Sorry, the page you are looking for does not exist.</p>
  </div>
);

export default NotFound;
